function init(options) {
    const browserWindow = options && options.window ? options.window : window;
    const browserDocument = options && options.document ? options.document : document;
    const hero = browserDocument.querySelector('[data-homepage-hero]');

    if (!hero) {
        return;
    }

    if (typeof browserWindow.MicroModal !== 'undefined') {
        browserWindow.MicroModal.init({
            openTrigger: 'data-modal-open',
            closeTrigger: 'data-modal-close',
            disableScroll: true,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });
    }

    const chooser = hero.querySelector('[data-homepage-chooser]');

    if (chooser) {
        const panels = chooser.querySelectorAll('[data-platform-services]');
        const updatePlatform = function (event) {
            const checked = chooser.querySelector('input[name="homepage-platform"]:checked');

            if (!checked) {
                return;
            }

            chooser.classList.toggle('has-platform-change', Boolean(event && event.type === 'change'));
            panels.forEach(function (panel) {
                panel.hidden = panel.dataset.platformServices !== checked.value;
            });
        };

        chooser.addEventListener('change', updatePlatform);
        browserWindow.addEventListener('pageshow', updatePlatform);
        updatePlatform();
    }

    const ticker = hero.querySelector('[data-homepage-completions]');
    const track = hero.querySelector('[data-homepage-completion-track]');

    if (typeof browserWindow.matchMedia !== 'function') {
        return;
    }

    const mobile = browserWindow.matchMedia('(max-width: 991px)');
    const reducedMotion = browserWindow.matchMedia('(prefers-reduced-motion: reduce)');

    if (!ticker || !track || typeof browserWindow.fetch !== 'function') {
        return;
    }

    let requested = false;
    let populated = false;
    let intersecting = false;
    let interval = null;
    let animation = null;
    let currentRow = 0;
    let rowCount = 0;
    let announcementCommand = null;

    const listen = function (target, eventName, handler) {
        if (typeof target.addEventListener === 'function') {
            target.addEventListener(eventName, handler);
        } else if (typeof target.addListener === 'function') {
            target.addListener(handler);
        }
    };

    const syncAnnouncement = function (force) {
        if (typeof browserWindow.jQuery !== 'function') {
            return;
        }

        const command = populated && mobile.matches && intersecting ? 'slickPause' : 'slickPlay';
        const slider = browserWindow.jQuery('.announcement-bar .slider-container.slick-initialized');

        if (!slider.length || typeof slider.slick !== 'function' || (!force && command === announcementCommand)) {
            return;
        }

        slider.slick(command);
        announcementCommand = command;
    };

    const stopMotion = function () {
        if (interval !== null) {
            browserWindow.clearInterval(interval);
            interval = null;
        }

        if (animation) {
            animation.cancel();
            animation = null;
            track.style.transform = 'translateY(-' + (currentRow * 100) + '%)';
        }
    };

    const updateAccessibility = function () {
        Array.prototype.forEach.call(track.children, function (row, index) {
            row.setAttribute('aria-hidden', index === currentRow ? 'false' : 'true');
        });
    };

    const canMove = function () {
        return populated
            && rowCount > 1
            && mobile.matches
            && intersecting
            && browserDocument.visibilityState === 'visible'
            && !reducedMotion.matches
            && typeof track.animate === 'function'
            && typeof browserWindow.IntersectionObserver === 'function';
    };

    const advance = function () {
        if (animation || !canMove()) {
            return;
        }

        const nextRow = currentRow + 1;
        animation = track.animate([
            {transform: 'translateY(-' + (currentRow * 100) + '%)'},
            {transform: 'translateY(-' + (nextRow * 100) + '%)'},
        ], {
            duration: 500,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        });
        animation.onfinish = function () {
            if (nextRow === rowCount) {
                currentRow = 0;
                track.style.transform = 'translateY(0)';
            } else {
                currentRow = nextRow;
                track.style.transform = 'translateY(-' + (currentRow * 100) + '%)';
            }
            animation = null;
            updateAccessibility();
        };
    };

    const reevaluate = function () {
        ticker.hidden = !populated || !mobile.matches;
        syncAnnouncement(false);

        if (!canMove()) {
            stopMotion();
            return;
        }

        if (interval === null) {
            interval = browserWindow.setInterval(advance, 3750);
        }
    };

    const loadMessages = function () {
        if (!mobile.matches || requested) {
            return;
        }

        requested = true;
        browserWindow.fetch(ticker.dataset.endpoint)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Completion messages unavailable');
                }

                return response.json();
            })
            .then(function (payload) {
                const items = payload && Array.isArray(payload.items) ? payload.items.filter(function (item) {
                    return item
                        && typeof item.label === 'string'
                        && item.label.trim()
                        && typeof item.relativeTime === 'string'
                        && item.relativeTime.trim();
                }) : [];

                if (!items.length) {
                    return;
                }

                items.forEach(function (item, index) {
                    const row = browserDocument.createElement('div');
                    row.className = 'homepage-completion-row';
                    const copy = browserDocument.createElement('span');
                    copy.className = 'homepage-completion-copy';
                    const label = browserDocument.createElement('strong');
                    label.textContent = item.label.trim();
                    copy.appendChild(label);
                    copy.appendChild(browserDocument.createTextNode(' abgeschlossen '));
                    const time = browserDocument.createElement('span');
                    time.className = 'homepage-completion-time';
                    time.textContent = item.relativeTime.trim();
                    row.appendChild(copy);
                    row.appendChild(time);
                    row.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
                    track.appendChild(row);
                });
                rowCount = items.length;
                if (rowCount > 1) {
                    const firstRowClone = track.children[0].cloneNode(true);
                    firstRowClone.setAttribute('aria-hidden', 'true');
                    track.appendChild(firstRowClone);
                }
                populated = true;
                reevaluate();
            })
            .catch(function () {});
    };

    listen(mobile, 'change', function () {
        browserWindow.postponedExecution(loadMessages);
        reevaluate();
    });
    listen(reducedMotion, 'change', reevaluate);
    browserDocument.addEventListener('visibilitychange', reevaluate);

    if (typeof browserWindow.IntersectionObserver === 'function') {
        const observer = new browserWindow.IntersectionObserver(function (entries) {
            const entry = entries[0];
            intersecting = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
            reevaluate();
        });
        observer.observe(ticker);
    }

    if (typeof browserWindow.jQuery === 'function') {
        browserWindow.jQuery(browserDocument)
            .off('slickReady.homepageHero')
            .on('slickReady.homepageHero', function () { syncAnnouncement(true); });
    }

    browserWindow.postponedExecution(loadMessages);
}

module.exports = {init: init};
